export const GET_LIST_START = "@casinos/GET_LIST_START";
export const GET_LIST_SUCCESS = "@casinos/GET_LIST_SUCCESS";
export const GET_LIST_FAIL = "@casinos/GET_LIST_FAIL";
export const GET_DETAIL_START = "@casinos/GET_DETAIL_START";
export const GET_DETAIL_SUCCESS = "@casinos/GET_DETAIL_SUCCESS";
export const GET_DETAIL_FAIL = "@casinos/GET_DETAIL_FAIL";
export const GET_ENVIRONMENTS_START = "@casinos/GET_ENVIRONMENTS_START";
export const GET_ENVIRONMENTS_SUCCESS = "@casinos/GET_ENVIRONMENTS_SUCCESS";
export const GET_ENVIRONMENTS_FAIL = "@casinos/GET_ENVIRONMENTS_FAIL";
export const GET_JURISDICTIONS_START = "@casinos/GET_JURISDICTIONS_START";
export const GET_JURISDICTIONS_SUCCESS = "@casinos/GET_JURISDICTIONS_SUCCESS";
export const GET_JURISDICTIONS_FAIL = "@casinos/GET_JURISDICTIONS_FAIL";
export const GET_INTEGRATION_SETUPS_START = "@casinos/GET_INTEGRATION_SETUPS_START";
export const GET_INTEGRATION_SETUPS_SUCCESS = "@casinos/GET_INTEGRATION_SETUPS_SUCCESS";
export const GET_INTEGRATION_SETUPS_FAIL = "@casinos/GET_INTEGRATION_SETUPS_FAIL";
export const GET_INTEGRATORS_START = "@casinos/GET_INTEGRATORS_START";
export const GET_INTEGRATORS_SUCCESS = "@casinos/GET_INTEGRATORS_SUCCESS";
export const GET_INTEGRATORS_FAIL = "@casinos/GET_INTEGRATORS_FAIL";
export const GET_SOFTWARE_START = "@casinos/GET_SOFTWARE_START";
export const GET_SOFTWARE_SUCCESS = "@casinos/GET_SOFTWARE_SUCCESS";
export const GET_SOFTWARE_FAIL = "@casinos/GET_SOFTWARE_FAIL";
export const GET_CONFIGURATION_START = "@casinos/GET_CONFIGURATION_START";
export const GET_CONFIGURATION_SUCCESS = "@casinos/GET_CONFIGURATION_SUCCESS";
export const GET_CONFIGURATION_FAIL = "@casinos/GET_CONFIGURATION_FAIL";
export const GET_SITES_START = "@casinos/GET_SITES_START";
export const GET_SITES_SUCCESS = "@casinos/GET_SITES_SUCCESS";
export const GET_SITES_FAIL = "@casinos/GET_SITES_FAIL";
